import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import RecipientItem from './RecipientItem.vue';
import LoadingBar from '@/components/LoadingBar.vue';

@Component({
  components: {
    RecipientItem,
    LoadingBar,
  },
})
export default class RecipientList extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  originRecipientList!: RecipientWithStatus[];
  
  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  setCheckList!: (payload: RecipientWithStatus[]) => void;

  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //
  @Prop({ type: Boolean }) isLoading!: boolean;
  @Prop({ type: Array }) recipientList!: RecipientWithStatus[];
}